import { css } from '@emotion/react'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel, Text } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { Fragment } from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'
import { isNumberInRange } from 'util/number/number-in-range'
import { IDADE_FORA_DE_RASTREIO_TEXT } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { EXAMES_CANCER_COLO_UTERO_TOOLTIP_TEXT, RANGE_IDADE_RASTREIO_CANCER_COLO_UTERO } from './constants-saudeMulher'

interface RastreamentoCancerColoUteroPanelProps {
  ultimaSolicitacao: LocalDate
  ultimaSolicitacaoNome: string
  ultimaAvaliacao: LocalDate
  ultimaAvaliacaoNome: string
  idadeCidadao: number
  iconColor: Color
}

export function RastreamentoCancerColoUteroPanel(props: Readonly<RastreamentoCancerColoUteroPanelProps>) {
  const {
    ultimaSolicitacao,
    ultimaSolicitacaoNome,
    ultimaAvaliacao,
    ultimaAvaliacaoNome,
    idadeCidadao,
    iconColor,
  } = props

  const isInRange = isNumberInRange(idadeCidadao, RANGE_IDADE_RASTREIO_CANCER_COLO_UTERO)

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} color={iconColor} />
          <Heading level={4}>Rastreio para câncer de colo de útero</Heading>
          <InfoIcon
            icon='infoCircleFilled'
            text={EXAMES_CANCER_COLO_UTERO_TOOLTIP_TEXT}
            tooltipStyle={styles.tooltipStyle}
          />
        </HFlow>
      </Cell>
      {isInRange ? (
        <Fragment>
          <Cell size={6}>
            <InfoLabel title='Última solicitação'>{format(ultimaSolicitacao, ultimaSolicitacaoNome)}</InfoLabel>
          </Cell>
          <Cell size={6}>
            <InfoLabel title='Última avaliação'>{format(ultimaAvaliacao, ultimaAvaliacaoNome)}</InfoLabel>
          </Cell>
        </Fragment>
      ) : (
        <Cell size={12}>
          <Text fontStyle='italic'>{IDADE_FORA_DE_RASTREIO_TEXT}</Text>
        </Cell>
      )}
    </Grid>
  )
}

const format = (data: LocalDate, nome: string): string => {
  if (isUndefinedOrNull(data)) return '-'
  return `${formatDate(data)} | ${nome}`
}

const styles = {
  tooltipStyle: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
}
